import { renderToString } from 'react-dom/server'
import { getElementSize, getTextSize } from '../helper'

export const getLabelSize = (
  payload,
  percent,
  index,
  fontSize,
  renderCustomLabel,
) => {
  if (renderCustomLabel) {
    const reactElementString = renderToString(
      renderCustomLabel(payload, percent, index),
    )
    return getElementSize(reactElementString, fontSize)
  } else {
    const text = `${(percent * 100).toFixed(2)}%`
    return getTextSize(text, fontSize)
  }
}
